import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  body {
    overflow: ${props => (props.lockScroll ? 'hidden' : 'auto')};
  }
`;

export default GlobalStyle;
